export const MOBILE_NAV_HEIGHT = 60;
export const MOBILE_NAV_ACTIVE = "#E8524A";
export const MOBILE_NAV_INACTIVE = "#B5B5C3";
export const MOBILE_NAV_BREAKPOINT = 992;
